import {QueryClientProvider} from '@tanstack/react-query'
import {ErrorBoundary} from 'react-error-boundary'
import {RouterProvider, createBrowserRouter, Navigate} from 'react-router-dom'
import {ErrorLayer} from '@src/Layers/ErrorLayer/ErrorLayer.tsx'
import {NotFountPage} from '@src/Layers/ErrorLayer/ErrorPage.tsx'
import {forgotPasswordRoute} from './Pages/ForgotPasswordPage/ForgotPasswordPage.tsx'
import {loginPageRoute} from './Pages/LoginPage/LoginPage.tsx'
import {queryClient} from './QueryClient/queryClient.ts'
import {mainRoute} from "./Features/MainLayout/MainRoute.tsx";


const router = createBrowserRouter([
    loginPageRoute,
    forgotPasswordRoute,
    mainRoute,
    {
        // convenience shortcut: /admin → backend Django admin
        path: '/admin/*',
        loader: ({params}) => {
            window.location.replace(new URL(`admin/${params['*'] ?? ''}`, import.meta.env.VITE_API_URL).href)
            return null
        },
        element: null
    },
    {
        path: '*',
        element: <NotFountPage/>
    },
    {
        path: "/",
        element: <Navigate to={"/check-in"}/>
    }
])


const App = () => (
    <ErrorBoundary fallback={<div>error</div>}>
        <QueryClientProvider client={queryClient}>
            <ErrorLayer>
                <RouterProvider router={router}/>
            </ErrorLayer>
        </QueryClientProvider>
    </ErrorBoundary>
)

export default App
